import React, { Component } from "react";
import { connect } from 'react-redux';
import DatePicker from 'react-datepicker';
import { setBitisTarihi } from "../../actions/Actions";
import 'react-datepicker/dist/react-datepicker.css';

class BitisTarih extends Component {
    render() {
        const { bitisTarihi } = this.props;

        return <DatePicker
            selected={bitisTarihi}
            onChange={this.props.setBitisTarihi}
            dateFormat="DD/MM/YYYY"
            className="form-control"
        />;
    }
}

const mapStateToProps = state => ({
    bitisTarihi: state.reducer.bitisTarihi
});

const mapDispatchToProps = dispatch => ({
    setBitisTarihi: (date) => { setBitisTarihi(dispatch, date); }
});

export default connect(mapStateToProps, mapDispatchToProps)(BitisTarih);


// WEBPACK FOOTER //
// ./src/components/containers/BitisTarih.js